import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

import Icon from '../Icon'
import { Link } from '../../gatsby-helpers'

import chevronRight from '../../assets/icons/chevron-right.svg'

const Button = ({
  classNames,
  children,
  type,
  pill,
  minor,
  ghost,
  invert,
  alt,
  noPadding,
  href,
  target,
  onClick,
  imageSrc
}) => {
  const className = cn(
    'Button',
    { pill, minor, ghost, invert, alt, noPadding },
    classNames
  )
  const content = (
    <>
      {imageSrc && <img className="Button__image" src={imageSrc} alt="" />}
      {children}
      {ghost && <Icon source={chevronRight} />}
    </>
  )

  if (href) {
    return (
      <Link className={className} href={href} target={target}>
        {content}
      </Link>
    )
  }

  return (
    <button className={className} type={type} onClick={onClick}>
      {content}
    </button>
  )
}

Button.defaultProps = {
  type: 'button'
}

Button.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit']),
  pill: PropTypes.bool,
  minor: PropTypes.bool,
  ghost: PropTypes.bool,
  invert: PropTypes.bool,
  alt: PropTypes.bool,
  noPadding: PropTypes.bool, // usage: in combination with `ghost` only!
  href: PropTypes.string,
  target: PropTypes.string, // usage: in combination with `href` only!
  onClick: PropTypes.func,
  imageSrc: PropTypes.string
}

export default Button
